import { PageHeader } from "@/components/common/PageHeader";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { SeverityChip } from "@/components/common/SeverityChip";
import { Check, Shield, X } from "lucide-react";

const RULES = [
  { data: "Public / general information", state: "allow", label: "Allowed", ex: "Marketing copy, public docs, brainstorming — use any approved tool." },
  { data: "Customer PII (email, phone)", state: "redact", label: "Redact first", ex: "Personal data is masked before it reaches the model on sanctioned tools." },
  { data: "Regulated IDs (Aadhaar, PAN, Emirates ID, cards)", state: "redact", label: "Redact first", ex: "Always redacted — replaced with <class> tokens automatically." },
  { data: "Private source code & secrets", state: "block", label: "Not allowed", ex: "Company code only goes to approved coding tools like Claude Code." },
  { data: "Highly confidential documents", state: "block", label: "Not allowed", ex: "Blocked from unsanctioned AI; use M365 Copilot or Claude Projects." },
];
const ICON = { allow: Check, redact: Shield, block: X };

export default function PolicyPlain() {
  return (
    <div>
      <PageHeader eyebrow="Navitra Companion" title="Policy in Plain Words" subtitle="What you can share with AI, by data type — with real examples. No legal jargon." />
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {RULES.map((r) => { const Icon = ICON[r.state]; return (
          <Card key={r.data} data-testid={`policy-plain-${r.state}`}>
            <CardHeader className="pb-2"><div className="flex items-start justify-between gap-2"><CardTitle className="text-base leading-snug">{r.data}</CardTitle><SeverityChip level={r.state} label={r.label} /></div></CardHeader>
            <CardContent><div className="flex gap-2 text-sm text-muted-foreground"><Icon className={`h-4 w-4 shrink-0 mt-0.5 ${r.state === "allow" ? "text-sev-success" : r.state === "redact" ? "text-sev-warning" : "text-sev-danger"}`} /><p>{r.ex}</p></div></CardContent>
          </Card>
        ); })}
      </div>
    </div>
  );
}
